import { Component, ViewChild, ElementRef , HostListener, Inject } from '@angular/core';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-questionlist-view',
  templateUrl: './questionlist-view.component.html',
  styleUrls: ['./questionlist-view.component.css']
})
export class QuestionListViewComponent {
  tableFilters = '';
  displayedColumns = ['loginId','createdDate' , 'otpPurpose', 'sharedkey', 'sessionId','firstName'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  showToolBar = false;
  screenHeight;
  screenWidth;
  salesChannelss;
  paymentDetais;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  questionList: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any ) {
    }

  ngOnInit() {
    this.questionList = this.data
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
}
